"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatStringToKey = exports.debateFormatToKey = exports.DebateFormatKey = exports.SpeechType = exports.TurnStatus = exports.Winner = exports.WinType = exports.Team = exports.TurnType = exports.formatKeyMap = exports.debateFormatMaxMembers = exports.DebateFormat = exports.UserSelectorOptions = exports.SpeakingRole = void 0;
var SpeakingRole;
(function (SpeakingRole) {
    SpeakingRole["Affirmative"] = "Affirmative";
    SpeakingRole["Negative"] = "Negative";
    SpeakingRole["Moderator"] = "Moderator";
    SpeakingRole["None"] = "None";
    SpeakingRole["Bot"] = "Bot";
})(SpeakingRole || (exports.SpeakingRole = SpeakingRole = {}));
var UserSelectorOptions;
(function (UserSelectorOptions) {
    UserSelectorOptions["Affirmative"] = "Affirmative";
    UserSelectorOptions["Negative"] = "Negative";
    UserSelectorOptions["Moderator"] = "Moderator";
    UserSelectorOptions["None"] = "None";
})(UserSelectorOptions || (exports.UserSelectorOptions = UserSelectorOptions = {}));
var DebateFormat;
(function (DebateFormat) {
    DebateFormat["LincolnDouglas"] = "Lincoln Douglas";
    DebateFormat["PublicForum"] = "Public Forum";
    DebateFormat["TeamPolicy"] = "Team Policy";
    DebateFormat["QuickRound"] = "Quick Round";
    // Extemp = 'Extemporaneous',
})(DebateFormat || (exports.DebateFormat = DebateFormat = {}));
// 2. Max members by internal format key
exports.debateFormatMaxMembers = {
    LincolnDouglas: 3,
    PublicForum: 2,
    TeamPolicy: 2,
    QuickRound: 3,
};
exports.formatKeyMap = {
    [DebateFormat.LincolnDouglas]: 'LincolnDouglas',
    [DebateFormat.PublicForum]: 'PublicForum',
    [DebateFormat.TeamPolicy]: 'TeamPolicy',
    [DebateFormat.QuickRound]: 'QuickRound',
};
var TurnType;
(function (TurnType) {
    TurnType["Affirmative"] = "Affirmative";
    TurnType["Negative"] = "Negative";
    TurnType["AffirmativeCrossNegative"] = "Affirmative cross Negative";
    TurnType["NegativeCrossAffirmative"] = "Negative cross Affirmative";
    TurnType["Preperatory"] = "Preperatory";
    TurnType["FreeForm"] = "FreeForm";
})(TurnType || (exports.TurnType = TurnType = {}));
var Team;
(function (Team) {
    Team["AFFIRMATIVE"] = "AFFIRMATIVE";
    Team["NEGATIVE"] = "NEGATIVE";
})(Team || (exports.Team = Team = {}));
var WinType;
(function (WinType) {
    WinType["SIMPLEPOLL"] = "SIMPLEPOLL";
    WinType["EVALUATIONPOLL"] = "EVALUATIONPOLL";
    WinType["AI"] = "AI";
    WinType["BALLOT"] = "BALLOT";
})(WinType || (exports.WinType = WinType = {}));
exports.Winner = {
    [SpeakingRole.Affirmative]: SpeakingRole.Affirmative,
    [SpeakingRole.Negative]: SpeakingRole.Negative,
    Tie: 'Tie',
    Undecided: 'Undecided',
};
var TurnStatus;
(function (TurnStatus) {
    TurnStatus["READY"] = "READY";
    TurnStatus["THINKING"] = "THINKING";
    TurnStatus["PLAYING"] = "PLAYING";
    TurnStatus["CANCELLED"] = "CANCELLED";
    TurnStatus["RECORDING"] = "RECORDING";
    TurnStatus["PAUSED"] = "PAUSED";
    TurnStatus["TURN_COMPLETE"] = "TURN_COMPLETE";
    TurnStatus["TURN_STARTING"] = "TURN_STARTING";
    TurnStatus["RESTART"] = "RESTART";
})(TurnStatus || (exports.TurnStatus = TurnStatus = {}));
var SpeechType;
(function (SpeechType) {
    SpeechType["AC1"] = "1AC";
    SpeechType["NC1"] = "1NC";
    SpeechType["AR1"] = "1AR";
    SpeechType["NR"] = "NR";
    SpeechType["NR2"] = "2NR";
    SpeechType["AR2"] = "2AR";
})(SpeechType || (exports.SpeechType = SpeechType = {}));
var DebateFormatKey;
(function (DebateFormatKey) {
    DebateFormatKey["LINCOLN_DOUGLAS"] = "lincolndouglas";
    DebateFormatKey["QUICK_ROUND"] = "quickround";
    DebateFormatKey["PUBLIC_FORUM"] = "publicforum";
    DebateFormatKey["POLICY"] = "policy";
})(DebateFormatKey || (exports.DebateFormatKey = DebateFormatKey = {}));
// Mapping function to convert between DebateFormat and DebateFormatKey
const debateFormatToKey = (format) => {
    switch (format) {
        case DebateFormat.LincolnDouglas:
            return DebateFormatKey.LINCOLN_DOUGLAS;
        case DebateFormat.QuickRound:
            return DebateFormatKey.QUICK_ROUND;
        case DebateFormat.PublicForum:
            return DebateFormatKey.PUBLIC_FORUM;
        case DebateFormat.TeamPolicy:
            return DebateFormatKey.POLICY;
        default:
            throw new Error(`Unsupported format: ${format}`);
    }
};
exports.debateFormatToKey = debateFormatToKey;
// Mapping function to convert display format string to DebateFormatKey
const formatStringToKey = (formatString) => {
    switch (formatString) {
        case 'Lincoln Douglas':
            return DebateFormatKey.LINCOLN_DOUGLAS;
        case 'Quick Round':
            return DebateFormatKey.QUICK_ROUND;
        case 'Public Forum':
            return DebateFormatKey.PUBLIC_FORUM;
        case 'Team Policy':
            return DebateFormatKey.POLICY;
        default:
            throw new Error(`Unsupported format: ${formatString}`);
    }
};
exports.formatStringToKey = formatStringToKey;
